import React from "react";
import Buttons from "../../../../Components/UI/Buttons";
import SubFormItem from "./SubFormItem";
import StepsSubFormItem from "./StepsSubFormItem";
import { isSet, normalizePicklistSelectedValue, getUserPreferredCurrencyCode } from "../../../../Utils/CommonFunctions";
import { connect } from "react-redux";
import {
  clearSubformValidation,
  setSubFormDataAction,
} from "../../../../store/actions/formBuilderActions";

const isSubformColumnVisible = (item, pageType) => {
  if (isSet(item.access_mode, "EDITABLE") === "HIDDEN") {
    return false;
  }
  if (pageType === "view") {
    return isSet(item.is_detail_view, true) !== false;
  }
  return isSet(item.is_add_form, false) === true;
};

const findSubformColumnValue = (columnValues, descriptorId) => {
  if (!columnValues || !descriptorId) {
    return null;
  }
  return (
    columnValues.find(
      (column) =>
        column.table_descriptor_id == descriptorId ||
        column.tableDescriptorId == descriptorId
    ) || null
  );
};

const SubFormRows = (props) => {
  const {
    rowIndex,
    subformIndex,
    rowData,
    sectionData,
    section,
    modType,
    pageType,
    subformData,
    isWrite,
    sectionType,
    sectionSubformData,
    reminderDisplayText,
  } = props;
  const removeSubFormsHandler = async (subformIndex, rowIndex) => {
    let display_postition = 0;
    if (pageType === "view") {
      // props.updateFormsInDetailView();
      // console.log('subformData[subformIndex].subform_rows[rowIndex].id',subformData[subformIndex].subform_rows[rowIndex]);
      props.removeSubformDataHandler(subformIndex, [
        subformData[subformIndex].subform_rows[rowIndex].id,
      ]);
    } else if (pageType === "form") {
      let subformDataRows = subformData[subformIndex].subform_rows.filter(
        (filter, filIndex) => {
          if (filIndex !== rowIndex) {
            filter.display_postition = display_postition;
            display_postition++;
            return filter;
          }
        }
      );
      subformData[subformIndex].subform_rows = subformDataRows;
      await props.setSubFormDataAction(modType, [...subformData]);
      // props.clearFormFieldValidationAction(modType);
      props.clearSubformValidation(modType, rowIndex);
     // props.updateSubformRow();
    }
  };
  const cancelSubFormsHandler = (subformIndex, rowIndex) => {
    let updateSubformData = [...subformData];
    updateSubformData[subformIndex].subform_rows[rowIndex].isOpenBox = false;
    let display_postition = 0;
    if (
      isSet(updateSubformData[subformIndex].subform_rows[rowIndex].id, null) ===
      null
    ) {
      let updateSubformDataRows = updateSubformData[
        subformIndex
      ].subform_rows.filter((filter, filIndex) => {
        if (filIndex !== rowIndex) {
          filter.display_postition = display_postition;
          display_postition++;
          return filter;
        }
      });
      updateSubformData[subformIndex].subform_rows = updateSubformDataRows;
    }
    props.setSubFormDataAction(modType, [...updateSubformData]);
  };

  //EDIT SUBFORM HANDLER
  const editSubFormsHandler = (subformIndex, rowIndex) => {
    subformData[subformIndex].subform_rows[rowIndex].isOpenBox = true;
    // console.log('subformData',subformData);
    props.setSubFormDataAction(modType, [...subformData]);
  };
  // SAVE SUBFORM HANDLER FROM
  const saveSubFormsHandler = (subformIndex, rowIndex) => {
    // console.log('subformData',modType,subformData,subformIndex,rowIndex);
    subformData[subformIndex].subform_rows[rowIndex].isOpenBox = false;
    // props.updateFormsInDetailView();
    props.saveAndUpdateSubform(rowIndex, true);
  };
  //COPY SUBFORM HANDLER
  const copySubFormsHandler = (subformIndex, rowIndex) => {
    const isShipments = props.windowName === 'Shipments';
    if (!isShipments && typeof props.onSubformActionStart === 'function') {
      props.onSubformActionStart();
    }
    const runUpdate = () => {
      let subformDataRows =
        subformData[subformIndex].subform_rows[rowIndex].subform_column_values;
      subformData[subformIndex].subform_rows.push({
        id: "",
        display_postition: subformData[subformIndex].subform_rows.length,
        is_selected: false,
        subform_column_values: subformDataRows.map((item) => {
          return {
            dpnm: item?.dpnm ?? '',
            table_descriptor_id: item.table_descriptor_id,
            display_name: item.display_name,
            selected_value: item.selected_value,
          };
        }),
      });
      let addedRowIndex = subformData[subformIndex].subform_rows.length - 1;
      subformData[subformIndex].subform_rows[addedRowIndex].isOpenBox = true;
      props.setSubFormDataAction(modType, [...subformData]);
      if (typeof props.onSubformRowAdded === 'function') {
        setTimeout(() => props.onSubformRowAdded(addedRowIndex), 0);
      }
    };
    if (isShipments) {
      runUpdate();
    } else if (typeof requestAnimationFrame !== 'undefined') {
      requestAnimationFrame(() => setTimeout(runUpdate, 0));
    } else {
      setTimeout(runUpdate, 0);
    }
  };
  const SubFormTypeComp =
    isSet(sectionType, "Default") === "Steps" ? StepsSubFormItem : SubFormItem;
  // Never coerce -1 → 0; that writes into the wrong subform after reload/merge
  if (subformIndex < 0) {
    return null;
  }
  const subFormIndex = subformIndex;
  let isDeleteIconshow = false,
    isEditIconshow = false,
    isSaveIconshow = false,
    isCopyIconshow = false;
  if (pageType === "form" && isWrite === true) {
    isDeleteIconshow = true;
    isCopyIconshow = true;
    if (sectionSubformData.subform_rows.length > 1 && sectionSubformData.subform_rows.filter((val)=>val.is_selected===true).length<=1) {
      isDeleteIconshow = true;
    } else {
      isDeleteIconshow = false;
    }
     if (sectionSubformData.subform_rows.length >= 1 && sectionSubformData.subform_rows.filter((val)=>val.is_selected===true).length<=1) {
      isCopyIconshow=true
    } else {
      isCopyIconshow=false
    }
  } else if (pageType === "view" && isWrite === true) {
    if (rowData.isOpenBox === true) {
      isDeleteIconshow = false;
      isEditIconshow = false;
      isSaveIconshow = true;
    } else if (sectionSubformData.subform_rows.length < 1) {
      isDeleteIconshow = false;
      isEditIconshow = true;
      isSaveIconshow = false;
    } else {
      isDeleteIconshow = true;
      isEditIconshow = true;
      isSaveIconshow = false;
    }
  }
  if(props.shouldRenderButton===false){
    isCopyIconshow = props.shouldRenderButton;
  }
  

  const buttonList = [
    {
      clickHandler: editSubFormsHandler.bind(
        this,
        subformIndex > 0 ? subformIndex : 0,
        rowIndex
      ),
      type: "edit",
      attributes: {
        className: "p-1",
      },
      svgIcon: "Edit",
      //access_mode:DVis_write === false ? false : (pageType==='form')?false:(rowData.isOpenBox===true)?false:true,
      access_mode: isEditIconshow,
    },
    {
      clickHandler: saveSubFormsHandler.bind(
        this,
        subformIndex > 0 ? subformIndex : 0,
        rowIndex
      ),
      type: "save",
      svgIcon: "Tick",
      svgSize: 20,
      attributes: {
        className: "p-1",
      },
      // iconClass:'fas fa-check primary_color',
      //access_mode:DVis_write === false ? false : (pageType==='view' && rowData.isOpenBox===true)?true:false,
      access_mode: isSaveIconshow,
    },
    {
      clickHandler: cancelSubFormsHandler.bind(
        this,
        subformIndex > 0 ? subformIndex : 0,
        rowIndex
      ),
      type: "cancel",
      svgIcon: "Cross",
      attributes: {
        className: "p-1",
      },
      // iconClass:'fas fa-check primary_color',
      //access_mode:DVis_write === false ? false : (pageType==='view' && rowData.isOpenBox===true)?true:false,
      access_mode: isSaveIconshow,
    },
    {
      clickHandler: copySubFormsHandler.bind(
        this,
        subformIndex > 0 ? subformIndex : 0,
        rowIndex
      ),
      type: "copy",
      attributes: {
        className: "p-1",
      },
      svgIcon: "Copy",
      access_mode: isCopyIconshow,
    },
    {
      clickHandler: removeSubFormsHandler.bind(
        this,
        subformIndex > 0 ? subformIndex : 0,
        rowIndex
      ),
      type: "delete",
      attributes: {
        className: "p-1",
      },
      svgIcon: "Delete",
      //access_mode:DVis_write === false ? false : (pageType==='form')?false:(rowData.isOpenBox===true)?false:true,
      //access_mode:DVis_write === false ? false : (sectionSubformData.subform_rows.length>1)?true:false,
      access_mode: isDeleteIconshow,
    },
    
  ];
  const trStyle = props.virtualizedRowHeight != null
    ? { height: props.virtualizedRowHeight, minHeight: props.virtualizedRowHeight, boxSizing: 'border-box' }
    : undefined;
  return (
    <tr
      key={rowIndex}
      data-row-index={props.dataRowIndex != null ? props.dataRowIndex : rowIndex}
      style={trStyle}
    >
        {isSet(props.isWrite,true)===true  && (
        <td className="fixed-first-col" style={{position: "sticky",left:0,zIndex:1,backgroundColor:"white"}}>
               {(pageType==='form' && sectionSubformData.subform_rows.length > 1 ) && <input type="checkbox" checked={rowData.is_selected} onClick={(e)=>props.selectData(rowIndex,e.target.checked)} />}
          <Buttons buttonList={buttonList} />
        </td>
        )}
      {sectionData.map((item, index) => {

        if (!isSubformColumnVisible(item, pageType)) {
          return false;
        }
        const columnData = findSubformColumnValue(
          rowData.subform_column_values,
          item.id
        ) || {};
        const columnIndex = Array.isArray(rowData.subform_column_values)
          ? rowData.subform_column_values.findIndex(function (
              column
            ) {
              return (
                column.table_descriptor_id == item.id ||
                column.tableDescriptorId == item.id
              );
            })
          : -1;
        if (columnIndex < 0) {
          return false;
        }

        let reminder = isSet(columnData.reminder, "");
        let files = isSet(columnData.files, "");
        let selectedValue = isSet(
          columnData.selected_value ?? columnData.selectedValue,
          ""
        );
        if (item.element === 'PickList') {
          selectedValue = normalizePicklistSelectedValue(
            { ...item, options: isSet(columnData.options, item.options) },
            selectedValue
          );
        }
        let selected_value_text = isSet(
          columnData.selected_value_text ?? columnData.selectedValueText,
          ""
        );
        let selecteddpnm = isSet(columnData.dpnm, "");
        let overridden = isSet(columnData.overridden, false);
        let currency_code = isSet(columnData.currency_code, getUserPreferredCurrencyCode() || "CAD");
        let from_currency = isSet(columnData.from_currency, currency_code);
        let exchange_rate = isSet(
          columnData.exchange_rate ?? columnData.exchangeRate,
          ""
        );
        let options = isSet(columnData.options, item.options);
        // console.log('columnData',rowIndex,columnData);
        return (
          <SubFormTypeComp
            key={"wrapingSubform_" + rowIndex + "_" + index + "" + columnIndex}
            keyIndex={rowIndex + "_" + index}
            item={item}
            subFormIndex={subFormIndex}
            rowIndex={rowIndex}
            isOpenBox={rowData.isOpenBox}
            rowId={rowData.id}
            reminder={reminder}
            files={files}
            selectedValue={selectedValue}
            selected_value_text={selected_value_text}
            selecteddpnm={selecteddpnm}
            overridden={overridden}
            currency_code={currency_code}
            from_currency={from_currency}
            exchange_rate={exchange_rate}
            options={options}
            section={section}
            modType={modType}
            columnIndex={columnIndex}
            windowDetails={props.windowDetails}
            isPopupWindow={props.isPopupWindow}
            onChangeInputAction={props.onChangeInputAction}
            pageType={pageType}
            layoutForms={true}
            reminderDisplayText={reminderDisplayText}
            sectionType={sectionType}
          />
        )
      })}
    </tr>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSubFormDataAction: (modType, data) =>
      dispatch(setSubFormDataAction(modType, data)),
    clearSubformValidation: (modType, row) =>
      dispatch(clearSubformValidation(modType, row)),
  };
};
const mapStateToProps = (state, props) => {
  return {
    // subformData:state.formBuilder.subformData[props.modType],
    // validationForms:state.formBuilder.validationForms[props.modType],
    subformData: state.formBuilder.subformData[props.modType],
    // subformValidation:state.formBuilder.subformValidation[props.modType],
  };
};
SubFormRows.defaultProps = {
  shouldRenderButton:true
}
export default connect(mapStateToProps, mapDispatchToProps)(SubFormRows);
// export default SubFormRows;